import { ResetPasswordComponent } from './reset-password.component';
import { AppSharedModule } from './../kuba/shared/appShared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ForgetPasswordComponent } from './forget-password.component';
import { NgModule } from '@angular/core';
import { PasswordValidatorModule } from '../shared/password-validator/password-validator.module';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';

@NgModule({
  imports: [
    CommonModule,
    InputTextModule,
    ButtonModule,
    MessageModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AppSharedModule,
    PasswordValidatorModule
  ],
  exports: [ForgetPasswordComponent, ResetPasswordComponent],
  declarations: [ForgetPasswordComponent, ResetPasswordComponent],
  providers: []
})
export class ForgetPasswordModule {}
